import {
  findById,
  findByIdThrows,
  getFulfilledUserNetworkLeaders,
  getStatusForId,
  hasUserNetworkLeaders,
} from '@ms/yammer-data/dist/domains/userNetworkLeaders/selectors';
import type { User } from '@ms/yammer-data/dist/state/types';

import { useSelector } from '../useSelector';

type UseUserNetworkLeaderThrows = (userId: User['id']) => ReturnType<typeof findByIdThrows>;
/**
 * @deprecated PERFORMANCE This selects an entity object, which will return a new instance and force re-renders
 * when changed. This should be replaced by a `useUserNetworkLeaderFieldThrows` selector.
 */
export const useUserNetworkLeaderThrows: UseUserNetworkLeaderThrows = (userId) =>
  useSelector((state) => findByIdThrows(state, userId));

type UseUserNetworkLeader = (userId: User['id']) => ReturnType<typeof findById>;
/**
 * @deprecated PERFORMANCE This selects an entity object, which will return a new instance and force re-renders
 * when changed. This should be replaced by a `useUserNetworkLeaderField` selector.
 */
export const useUserNetworkLeader: UseUserNetworkLeader = (userId) => useSelector((state) => findById(state, userId));

type UseLeaderStatus = (userId: User['id']) => ReturnType<typeof getStatusForId>;
export const useLeaderStatus: UseLeaderStatus = (userId) => useSelector((state) => getStatusForId(state, userId));

type UseFulfilledUserNetworkLeaders = () => ReturnType<typeof getFulfilledUserNetworkLeaders>;
/**
 * @deprecated PERFORMANCE This selects an object containing all fulfilled entities, which will return a new object
 * instance and force re-renders when ANY network leader changes in the store. This selector should be deleted.
 */
export const useFulfilledUserNetworkLeaders: UseFulfilledUserNetworkLeaders = () =>
  useSelector(getFulfilledUserNetworkLeaders);

type UseHasUserNetworkLeaders = () => ReturnType<typeof hasUserNetworkLeaders>;
export const useHasUserNetworkLeaders: UseHasUserNetworkLeaders = () => useSelector(hasUserNetworkLeaders);
